export default __webpack_public_path__ + "static/logo-10968976818e28fd8eee91f66d535d9a.svg";